/**
 * Situacao do palpite
 */
export enum PredictionsStatus {
  /**
   * Publicada
   */
  PUBLISHED = 'PUBLISHED',

  /**
   * Não publicada
   */
  NOT_PUBLISHED = 'NOT_PUBLISHED',

  /**
   * Rascunho
   */
  DRAFT = 'DRAFT',

  /**
   * Deletado
   */
  DELETED = 'DELETED',
}

export const translatePredictionsStatus = (status: PredictionsStatus): string => {
  switch (status) {
    case PredictionsStatus.PUBLISHED:
      return 'Publicado';
    case PredictionsStatus.NOT_PUBLISHED:
      return 'Não publicado';
    case PredictionsStatus.DRAFT:
      return 'Rascunho';
    default:
      return status;
  }
};

/**
 * Tipo de interatividade
 */
export enum PredictionsInteractivity {
  /**
   * Ativa
   */
  ENABLED = 'ENABLED',
  /**
   * Encerrada
   */
  CLOSED = 'CLOSED',
}

export const translatePredictionsInteractivity = (status: PredictionsInteractivity): string => {
  switch (status) {
    case PredictionsInteractivity.ENABLED:
      return 'Ativo';
    case PredictionsInteractivity.CLOSED:
      return 'Encerrado';
    default:
      return status;
  }
};

export class PredictionsRankingItem {
  rank: number;
  account_uuid: string;
  account_avatar_url: string;
  account_display_name: string;
  total_points: number;
  total_hits: number;
  total_predictions: number;
  hit_percentage: number;
  last_vote_at: string;
}

export class PredictionsResultBreakdownItem {
  option_a_result: number;
  option_b_result: number;
  total_participations: number;
  percentage: number;
}

export class PredictionsResult {
  uuid: string;
  identifier: string;
  title: string;
  description: string;
  start_date: string;
  closing_date: string | null;
  closed_at: string | null;
  option_a_name: string;
  option_a_result: number | null;
  option_a_image_url: string | null;
  option_b_name: string;
  option_b_result: number | null;
  option_b_image_url: string | null;
  total_participants: number;
  total_hits: number;
  hit_percentage: number;
  breakdown: PredictionsResultBreakdownItem[];
}

export class Predictions {
  uuid: string;
  title: string;
  description: string;
  identifier: string;
  status: PredictionsStatus;
  interactivity: PredictionsInteractivity;
  option_a_name: string;
  option_a_result: string;
  option_a_image_url: string;
  option_b_name: string;
  option_b_result: string;
  option_b_image_url: string;
  disable_comments: boolean;
  enable_home: boolean;
  total_participants: number;
  total_comments: number;
  total_hits: number;
  closing_date?: string | null;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  created_at: string;
  updated_at: string;
}
